import { render, staticRenderFns } from "./JewelDescriptionTooltip.vue?vue&type=template&id=2dc081ec&scoped=true&"
import script from "./JewelDescriptionTooltip.vue?vue&type=script&lang=js&"
export * from "./JewelDescriptionTooltip.vue?vue&type=script&lang=js&"
import style0 from "./JewelDescriptionTooltip.vue?vue&type=style&index=0&id=2dc081ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc081ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc081ec')) {
      api.createRecord('2dc081ec', component.options)
    } else {
      api.reload('2dc081ec', component.options)
    }
    module.hot.accept("./JewelDescriptionTooltip.vue?vue&type=template&id=2dc081ec&scoped=true&", function () {
      api.rerender('2dc081ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JewelDescriptionTooltip.vue"
export default component.exports